import React from "react";
import styles from './Buttons.module.css';
import { useDispatch } from "react-redux";
import { loginRequest } from "../../app/utils/authConfig";
import Button from "react-bootstrap/Button";
import mslogo from "../../assets/images/microsoft.png";
import Langs from "../../app/lang/langs";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import {
    checkMSToken
} from '../../containers/login/loginSlice'

export const SignInButton = () => {

    const { instance, accounts, inProgress } = useMsal()
    const dispatch = useDispatch()
    const isAuthenticated = useIsAuthenticated()

    function handleLogin(instance) {
        if (isAuthenticated) {
            const request = {
                ...loginRequest,
                account: accounts[0]
            }
            instance.acquireTokenSilent(request).then((response) => {
                dispatch(checkMSToken(response)).then((res) => {
                    if (res && res.payload && res.payload["responseError"] && res.payload["responseError"]["status"] == 401) {
                        if (response && response.account && response.account["username"]) {
                            instance.logout(response.account["username"])
                        }
                    }
                })
            }).catch((e) => {
                instance.acquireTokenPopup(request).then((response) => {
                    dispatch(checkMSToken(response))
                })
            })
        } else {
            instance.loginRedirect(loginRequest).catch(e => {
                console.error(e)
            })
            /*instance.loginPopup(loginRequest).catch(e => {
                console.error(e)
            })*/
        }
    }

    return (
        <Button variant="primary" className={styles.themeButtonLogin}
            onClick={() => handleLogin(instance)}>
            <img src={mslogo} />
            <Langs str="CONNECT_WITH_MICROSOFT" />
        </Button>
    )
}